
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable()
export class ResponseDataInterceptor implements HttpInterceptor {
	intercept ( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		return next.handle( req ).pipe( map( event => {
			if ( event instanceof HttpResponse && event.body ) {
				if ( 'data' in event.body && 'code' in event.body && 'message' in event.body ) {
					if ( 'error' in event.body ) {
						// todo error logging
						console.error( event.body );
						return event;
					} else {
						// Preserve extra fields (e.g. temporaryPassword for approvedUser) so callers can use them
						const body = event.body as { data: unknown; temporaryPassword?: string };
						if ( body.temporaryPassword !== undefined ) {
							return event.clone<any>( { body: { data: body.data, temporaryPassword: body.temporaryPassword } } );
						}
						return event.clone<any>( { body: event.body.data } );
					}
				}
			}
			return event;
		} ) );
	}
}
